<template>
  <div class="text-xs-center" v-if="config.format == 'chip'">
    <v-chip
      v-for="(role, role_id) in roles"
      :key="role_id"
      color="grey lighten"
      text-color="white"
    >{{ role.description }}</v-chip>
  </div>
  <span v-else-if="config.format == 'list'">
    <span v-for="(role, role_id) in roles" :key="role_id">
      <span>{{ role.description }}</span>
      <span v-if="role_id < roles.length - 1">,&nbsp;</span>
    </span>
  </span>
</template>

<script>
import { mapGetters } from "vuex";
import { api } from "@/store/modules/users";

import _ from "lodash";

export default {
  props: {
    currentUserId: {
      type: String,
      default: "nouser"
    }
  },
  data() {
    return {
      config: {
        displayName: "displayName",
        email: "email",
        avatar: "avatar",
        format: "list" // chip,list,more to come
      }
    };
  },
  computed: {
    ...mapGetters(api.namespace, [api.getters.getRolesByUser]),
    roles() {
      const roles = this.getRolesByUser(this.currentUserId);
      const filtered_roles = _.filter(roles, "member");
      //console.log("Rollen per User", roles)
      //console.log("Filt Rollen per User", filtered_roles)

      return filtered_roles;
    }
  },
  watch: {
    roles() {
      //.log("New Role", val)
    }
  }
};
</script>
